import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import "../Resume-Upload/ResumeUpload.css";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import UploadIcon from "../../Assets/Images/upload.svg";
import uploadButton from "../../Assets/Images/upload-button.svg";
import {
  displayFileName,
  CustomDragAndDrop,
  handleFileSelect,
} from "../../Common/Common-Function/CommonFunctions";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "../../Common/Button/Button";
import ResumeParser from "../Resume-Parser/ResumeParser";
import FileIcon from "../../Common/Common-Function/IconMapping";
import AureliaDarkIcon from "../../Assets/Images/resume-parser-header-darkicon.svg";
import {
  RESUME_PARSER_BASE_URL,
  PARSED_RESUME_URL,
  PROCESS_UPLOAD_FILE,
  WEB_SOCKET_URL,
  CREATE_RUN_SET_ID,
  VYLABS_BASE_URL,
  GET_UNPARSED_RESUMES_COUNT,
  VENDORS_SEARCH,
  PROCESS_EXCEL_URL,
} from "../../helper/url_helper";
import { DynamicContext } from "../../Context/DynamicContext";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { post, get } from "../../helper/Api_helper";
import { StandardPopup } from "../../Common/PopupStyles/PopupComponent.js";
import DynamicAutocomplete from "../../Common/AutoSuggestion/DynamicAutocomplete";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import SpreadsheetResults from "./SpreadsheetResults.js";
import { ReactComponent as ResumeIcon } from "../../Assets/Images/ResumeIcon.svg";
import { ReactComponent as SpreadsheetIcon } from "../../Assets/Images/SpreadsheetIcon.svg";
import backArrowIcon from "../../Assets/Images/arrow-back-icon.png";
import CandidateLightIcon from "../../Assets/Images/candidates-header-icon.svg";
import CandidateDarkIcon from "../../Assets/Images/candidates-header-darkicon.svg";
import RPHeaderDarkIcon from "../../Assets/Images/RP Page Header Icon - Dark.svg";
import RPHeaderLightIcon from "../../Assets/Images/RP Page Header Icon - Light.svg";

function FileUploadContainer(props) {
  const {
    isDarkMode,
    setShowResumeParser,
    showResumeParser,
    resetWebSocket,
    UploadedResumes,
    setUploadedResumes,
    incompleteFiles,
    setIncompleteFiles,
    parsedData,
    setParsedData,
    incompleteData,
    setIncompleteData,
    runSetId,
    setRunSetId,
    errorMessages,
    setErrorMessages,
    successMessages,
    setSuccessMessages,
    showFailedTab,
    setShowFailedTab,
    spreadsheetResults,
    setSpreadsheetResults,
    failedSpreadsheets,
    setFailedSpreadsheets,
    showSpreadsheetResults,
    setShowSpreadsheetResults,
    uploadType,
    setUploadType,
    spreadsheetLoading,
    setSpreadsheetLoading,
    socketRef,
    pingIntervalRef,
  } = useContext(DynamicContext);
  const {
    showHeader = true,
    isComingFromCandidates = false,
    handleCloseUploadResumeView = () => {},
  } = props || {};
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [parsedResumeData, setParsedResumeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [showVendorPopup, setShowVendorPopup] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [failedFileRetryCounts, setFailedFileRetryCounts] = useState({});
  const [retryApiResponses, setRetryApiResponses] = useState(() => {
    try {
      const saved = localStorage.getItem("retryApiResponses");
      return saved ? JSON.parse(saved) : {};
    } catch (error) {
      return {};
    }
  });
  const [excelRunId, setExcelRunId] = useState("");
  const [resumeRunId, setResumeRunId] = useState("");
  useEffect(() => {
    localStorage.setItem(
      "retryApiResponses",
      JSON.stringify(retryApiResponses),
    );
  }, [retryApiResponses]);
  const {
    isUploading,
    setIsUploading,
    parsedFiles,
    setParsedFiles,
    failedFiles,
    setFailedFiles,
    isVendorFeatureEnabled,
  } = useContext(DynamicContext);
  const fileRef = useRef();
  const reconnectAttempts = useRef(0);
  const reconnectTimeoutRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const timeoutsRef = useRef({});
  const timeoutRef = useRef(null);
  const responseReceivedRef = useRef(false);
  const isConnectingRef = useRef(false);
  const messageQueueRef = useRef([]);
  const lastMessageRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const unparsedCountIntervalRef = useRef(null);
  const unparsedCountTimeoutRef = useRef(null);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const allowedFileTypes =
    uploadType === "resume" ? [".pdf", ".doc", ".docx", ".txt",".html"] : [".xlsx",".csv"];
  const runSetIdRef = useRef(null);
  const allProcessedHandledRef = useRef(false);
  const runActiveRef = useRef(false);
  const retryFilesRef = useRef(new Set());
  const retryRunSetIdRef = useRef(null);
  const excelRunIdRef = useRef("");
  const resumeRunIdRef = useRef("");

  useEffect(() => {
    runSetIdRef.current = runSetId;
  }, [runSetId]);

  const handleUploadTypeChange = (event, newType) => {
    if (newType !== null) {
      setUploadType(newType);
      setUploadedResumes([]);
      if (fileRef.current) {
        fileRef.current.value = "";
      }
    }
  };

  const handleClickUpload = () => {
    fileRef.current.click();
  };

  const processExcelFile = async (fileNames, runSetId) => {
    const token = localStorage.getItem("token");
    const requestBodyData = {
      fileNames: fileNames,
      runSetID: runSetId,
    };

    const requestBody = JSON.stringify(requestBodyData);
    try {
      const response = await fetch(RESUME_PARSER_BASE_URL + PROCESS_EXCEL_URL, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error("Failed to process Excel file");
      }

      const runId = await response.json();
      setExcelRunId(runId?.run_id);
      excelRunIdRef.current = runId.run_id;
      return runId;

    } catch (error) {
      console.error("Error processing Excel file:", error);
      throw error;
    }
  };

  const handleSpreadsheetSubmit = async () => {
    if (UploadedResumes.length > 0) {
      allProcessedHandledRef.current = false;
      runActiveRef.current = true;
      setSpreadsheetResults([]);
      setFailedSpreadsheets([]);
      setShowSpreadsheetResults(true);
      setSpreadsheetLoading(true);
      setIsUploading(true);
      setLoading(true);

      try {
        const runSetId = await createRunSetId();
        if (!runSetId) {
          setIsUploading(false);
          setLoading(false);
          setSpreadsheetLoading(false);
          return;
        }
        initializeWebSocket();
        const fileNames = UploadedResumes.map((file) => file.name);
        const presignedUrls = await getPresignedUploadUrls(fileNames);

        if (presignedUrls.length === 0) {
          setIsUploading(false);
          setLoading(false);
          setSpreadsheetLoading(false);
          return;
        }

        const uploadPromises = UploadedResumes.filter(
          (file, index) => presignedUrls[index],
        ).map((file, index) => {
          const presignedUrl = presignedUrls[index];
          return fetch(presignedUrl, {
            method: "PUT",
            body: file,
            headers: {
              "Content-Type": "application/octet-stream",
            },
          });
        });

        await Promise.all(uploadPromises);
        await processExcelFile(fileNames, runSetId);
      } catch (error) {
        console.error("Error in handleSpreadsheetSubmit:", error);
        setSpreadsheetLoading(false);
        setIsUploading(false);
      } finally {
        setLoading(false);
      }
    } else {
      Toast("error", "Please upload a spreadsheet file");
      setSpreadsheetLoading(false);
    }
  };

  const assignVendorToCandidates = async (vendorId) => {
    if (!vendorId) {
      Toast("error", "Please select a vendor before assigning");
      return false;
    }
    try {
      setSelectedVendorId(vendorId);
      setShowVendorPopup(false);
      Toast(
        "success",
        "The selected vendor will be assigned to all parsed resume candidates.",
      );
      return true;
    } catch (error) {
      console.error("Error assigning vendor:", error);
      return false;
    }
  };
  const handleAddVendorClick = () => {
    setShowVendorPopup(true);
    setSelectedVendorId("");
  };
  const fetchVendors = async (inputValue = "") => {
    try {
      setVendorOptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
      );
      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors
            .filter((v) => v?.id && v?.name)
            .map((v) => ({
              label: v.contact_person
                ? `${v.name} - ${v.contact_person}`
                : v.name,
              value: v.id,
            }))
        : [];
      setVendorList(fetchedVendors);
    } catch (err) {
      console.error("fetchVendors error", err);
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };
  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchVendors(value);
    } else {
      setVendorList([]);
    }
  };
  const handleClear = () => {
    setUploadedResumes([]);
    setSelectedVendorId("");
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };
  const createRunSetId = async () => {
    try {
      const response = await post(VYLABS_BASE_URL, CREATE_RUN_SET_ID, {
        folderName: UploadedResumes.map((file) => file.name).join(","),
        totalFiles: UploadedResumes.length,
      });
      setRunSetId(response);
      return response;
    } catch (error) {
      console.error("Error creating run set ID:", error);
      return null;
    }
  };
  const getUnparsedResumesCount = async (runSetId) => {
    try {
      const response = await post(VYLABS_BASE_URL, GET_UNPARSED_RESUMES_COUNT, {
        runSetID: runSetId,
      });
      return response || {};
    } catch (error) {
      console.error("Error getting unparsed resumes count:", error);
      return {};
    }
  };
  const handleFileDragUpload = (droppedFiles) => {
    if (isUploading) {
      Toast("error", "Please wait, file processing is still in progress.");
      return;
    }
    const newFiles = handleFileSelect(droppedFiles, allowedFileTypes, 10);
    setUploadedResumes((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((file) => file.name));
      const duplicateFiles = newFiles.filter((file) =>
        existingFileNames.has(file.name),
      );
      const uniqueFiles = newFiles.filter(
        (file) => !existingFileNames.has(file.name),
      );
      if (duplicateFiles.length > 0) {
        Toast("error", "There are no duplicate files accepted.");
      }
      return [...prevFiles, ...uniqueFiles];
    });
  };
  const { handleDragEnter, isDragging } = CustomDragAndDrop(
    handleFileDragUpload,
    true,
  );
  const handleDrop = async (e) => {
    e.preventDefault();
    const listItems = e.dataTransfer.items;
    const newFiles = [];
    for (const item of listItems) {
      const contentEntry = item.webkitGetAsEntry?.();
      if (!contentEntry || !contentEntry.isFile) continue;
      const file = item.getAsFile();
      if (file) {
        newFiles.push(file);
      }
    }
    if (newFiles.length > 0) {
      const filesToUpload = newFiles.filter((file) => {
        const extension = `.${file.name.split(".").pop().toLowerCase()}`;
        return allowedFileTypes.includes(extension);
      });
      const nonAllowedFiles = newFiles.filter((file) => {
        const extension = `.${file.name.split(".").pop().toLowerCase()}`;
        return !allowedFileTypes.includes(extension);
      });
      const allowedExtensions =
        uploadType === "resume" ? "PDF, DOC, DOCX, and TXT" : "XLSX,CSV";
      if (nonAllowedFiles.length > 0) {
        Toast("error", `Only ${allowedExtensions} files are accepted.`);
        return;
      }
      setUploadedResumes((prevFiles) => {
        const existingFileNames = new Set(prevFiles.map((file) => file.name));
        const duplicateFiles = filesToUpload.filter((file) =>
          existingFileNames.has(file.name),
        );
        const uniqueFiles = filesToUpload.filter(
          (file) => !existingFileNames.has(file.name),
        );
        if (duplicateFiles.length > 0) {
          Toast("error", "Duplicate files are not accepted.");
        }
        return [...prevFiles, ...uniqueFiles];
      });
    }
  };
  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);
    if (isUploading) {
      Toast("error", "Please wait, file processing is still in progress.");
      return;
    }
    const filesToUpload = files.filter((file) => {
      const extension = `.${file.name.split(".").pop().toLowerCase()}`;
      return allowedFileTypes.includes(extension);
    });
    const nonAllowedFiles = files.filter((file) => {
      const extension = `.${file.name.split(".").pop().toLowerCase()}`;
      return !allowedFileTypes.includes(extension);
    });
    const allowedExtensions =
      uploadType === "resume" ? "PDF, DOC, DOCX, and TXT" : "XLSX,CSV";
    if (nonAllowedFiles.length > 0) {
      Toast("error", `Only ${allowedExtensions} files are accepted.`);
      return;
    }
    const newFiles = handleFileSelect(filesToUpload, allowedFileTypes, 10);
    setUploadedResumes((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((file) => file.name));
      const duplicateFiles = newFiles.filter((file) =>
        existingFileNames.has(file.name),
      );
      const uniqueFiles = newFiles.filter(
        (file) => !existingFileNames.has(file.name),
      );
      if (duplicateFiles.length > 0) {
        Toast("error", "Duplicate files are not accepted.");
      }
      if (fileRef.current) {
        fileRef.current.value = "";
      }
      return [...prevFiles, ...uniqueFiles];
    });
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const closeWebSocket = () => {
    if (socketRef.current) {
      console.log("Closing WebSocket connection");
      socketRef.current.close(1000, "Timeout or manual closure");
      socketRef.current = null;
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
    if (unparsedCountIntervalRef.current) {
      clearInterval(unparsedCountIntervalRef.current);
      unparsedCountIntervalRef.current = null;
    }
    if (unparsedCountTimeoutRef.current) {
      clearTimeout(unparsedCountTimeoutRef.current);
      unparsedCountTimeoutRef.current = null;
    }
    setCountdown(null);
  };
  const scheduleUnparsedResumesCount = async (runSetId) => {
    if (!runSetId) {
      console.error("No runSetId provided for scheduleUnparsedResumesCount");
      return;
    }
    setCountdown(300);
    countdownIntervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownIntervalRef.current);
          countdownIntervalRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    const callUnparsedResumesCount = async (attemptCount, final = false) => {
      try {
        const unparsedData = await getUnparsedResumesCount(runSetId);
        if (unparsedData) {
          const completedSet = new Set(
            unparsedData.completed_files?.map((f) => f.name) || [],
          );
          const failedSet = new Set(
            unparsedData.failed_files?.map((f) => f.name) || [],
          );
          const incompleteSet = new Set(
            unparsedData.incomplete_files?.map((f) => f.name) || [],
          );
          const completed =
            unparsedData.completed_files?.map((file) => ({
              id: file.id,
              name: file.name,
              presigned_url: file.presigned_url,
              candidate_id: file.candidate_id,
              candidate_creation_status: file.candidate_creation_status,
              created_at: file.created_at,
              updated_at: file.updated_at,
            })) || [];
          setParsedData((prev) => {
            const newCompletedItems = completed.map((newFile) => {
              const existingFile = prev.find((p) => p.name === newFile.name);
              if (existingFile) {
                return {
                  ...newFile,
                  created_at: newFile.created_at || existingFile.created_at,
                  updated_at: newFile.updated_at || existingFile.updated_at,
                };
              }
              return newFile;
            });
            return [...prev.filter((p) => !completedSet.has(p.name)), ...newCompletedItems];
          });
          setParsedFiles((prev) => [
            ...prev.filter((p) => !completedSet.has(p.name)),
            ...UploadedResumes.filter((file) => completedSet.has(file.name)),
          ]);
          const incomplete =
            unparsedData.incomplete_files?.map((file) => ({
              id: file.id,
              name: file.name,
              presigned_url: file.presigned_url,
            })) || [];
          setIncompleteData((prev) => {
            const byKey = new Map(
              prev.map((item) => [item.id || item.name, item]),
            );
            const mergedIncomplete =
              unparsedData.incomplete_files?.map((file) => {
                const key = file.id || file.name;
                const existing = byKey.get(key) || {};
                return {
                  ...existing,
                  ...file,
                };
              }) || [];

            return [
              ...prev.filter((i) => !incompleteSet.has(i.name)),
              ...mergedIncomplete,
            ];
          });
          setIncompleteFiles((prev) => [
            ...prev.filter((i) => !incompleteSet.has(i.name)),
            ...UploadedResumes.filter((file) => incompleteSet.has(file.name)),
          ]);
          if (final) {
            const failed = UploadedResumes.filter((file) =>
              failedSet.has(file.name),
            );
            setErrorMessages([
              ...failed.map((file) => `${file.name}: Failed to parse`),
              ...incomplete.map((file) => `${file.name}: Incomplete parsing`),
            ]);
            setFailedFiles((prev) => [
              ...prev.filter((f) => !failedSet.has(f.name)),
              ...failed,
            ]);
            setShowFailedTab(true);
          } else {
            setErrorMessages([]);
          }
          setSuccessMessages(
            completed.map(
              (file) => `Candidate created successfully for ${file.name}`,
            ),
          );
        }
      } catch (error) {
        console.error("Error in callUnparsedResumesCount:", error);
      }
    };
    unparsedCountTimeoutRef.current = setTimeout(async () => {
      if (!runActiveRef.current) return;
      await callUnparsedResumesCount(1);
      let attemptCount = 1;
      unparsedCountIntervalRef.current = setInterval(async () => {
        if (!runActiveRef.current) {
          clearInterval(unparsedCountIntervalRef.current);
          unparsedCountIntervalRef.current = null;
          return;
        }
        attemptCount += 1;
        const isFinal = attemptCount >= 10;
        await callUnparsedResumesCount(attemptCount, isFinal);
        if (isFinal) {
          clearInterval(unparsedCountIntervalRef.current);
          unparsedCountIntervalRef.current = null;
        }
      }, 30000);
    }, 30000);
  };
  const handlesubmit = async () => {
    if (uploadType === "spreadsheet") {
      handleSpreadsheetSubmit();
      return;
    }
    if (UploadedResumes.length > 0) {
      allProcessedHandledRef.current = false;
      runActiveRef.current = true;
      setShowResumeParser(true);
      setIsUploading(true);
      setLoading(true);
      try {
        const runSetId = await createRunSetId();
        if (!runSetId) {
          setIsUploading(false);
          setLoading(false);
          return;
        }
        initializeWebSocket();
        await scheduleUnparsedResumesCount(runSetId);
        const fileNames = UploadedResumes.map((file) => file.name);
        const presignedUrls = await getPresignedUploadUrls(fileNames);
        if (presignedUrls.length === 0) {
          setIsUploading(false);
          setLoading(false);
          return;
        }
        const uploadPromises = UploadedResumes.filter(
          (file, index) => presignedUrls[index],
        ).map((file, index) => {
          const presignedUrl = presignedUrls[index];
          return fetch(presignedUrl, {
            method: "PUT",
            body: file,
            headers: {
              "Content-Type": "application/octet-stream",
            },
            mode: "cors",
          })
            .then((response) => {
              if (!response.ok) {
                console.error(`File ${file.name} upload failed.`);
              }
            })
            .catch((error) => {
              console.error(`Upload error for ${file.name}:`, error);
            });
        });
        await Promise.all(uploadPromises);
        await Promise.race([
          processUploadedFile(fileNames, selectedVendorId),
          new Promise((_, reject) =>
            setTimeout(
              () => reject(new Error("PROCESS_UPLOAD_FILE timeout")),
              30000,
            ),
          ),
        ]).catch((error) => {
          console.error("Error in processUploadedFile:", error);
          return null;
        });
      } catch (error) {
        console.error("Error in handlesubmit:", error);
      } finally {
        setLoading(false);
      }
    } else {
      Toast("error", "Please upload a file");
      setLoading(false);
    }
  };
  const getPresignedUploadUrls = async (files) => {
    const token = localStorage.getItem("token");
    const requestBody = JSON.stringify({ FileNames: files });
    try {
      const response = await fetch(RESUME_PARSER_BASE_URL + PARSED_RESUME_URL, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });
      const data = await response.json();
      return data.PresignedUploadURLs;
    } catch (error) {
      console.error("Error:", error);
      return [];
    }
  };
  const processUploadedFile = async (fileNames, vendorId = null) => {
    let requestUrl = RESUME_PARSER_BASE_URL + PROCESS_UPLOAD_FILE;
    const token = localStorage.getItem("token");
    const requestBodyData = {
      fileNames: fileNames,
      runSetID: runSetIdRef.current,
    };
    if (vendorId) {
      requestBodyData.VendorID = vendorId;
    }
    const requestBody = JSON.stringify(requestBodyData);
    try {
      const response = await fetch(requestUrl, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });
      const runId = await response.json();
      setResumeRunId(runId);
      resumeRunIdRef.current = runId;
    } catch (error) {
      console.error("Error processing file:", error);
      return null;
    }
  };
  useEffect(() => {
    const totalHandled =
      parsedFiles.length + failedFiles.length + incompleteFiles.length;
    if (
      runActiveRef.current &&
      totalHandled === UploadedResumes.length &&
      UploadedResumes.length > 0
    ) {
      if (allProcessedHandledRef.current) return;
      allProcessedHandledRef.current = true;
      runActiveRef.current = false;
      console.log("All files processed, closing WebSocket");
      setIsUploading(false);
      closeWebSocket();

      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
        countdownIntervalRef.current = null;
        setCountdown(null);
      }
      if (uploadType === "resume") {
        Toast("success", "All resumes have been processed.");
      } else {
        Toast("success", "All spreadsheets have been processed.");
      }
    }
  }, [parsedFiles, failedFiles, incompleteFiles, UploadedResumes, uploadType]);
  useEffect(() => {
    if (UploadedResumes.length === 0) {
      allProcessedHandledRef.current = false;
      runActiveRef.current = false;
    }
  }, [UploadedResumes]);
  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }
    if (
      uploadType === "spreadsheet" &&
      socketRef.current &&
      socketRef.current.readyState === WebSocket.OPEN
    ) {
      console.log("Reusing existing WebSocket connection for spreadsheet");
      attachWebSocketListeners(socketRef.current);
      return;
    }

    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    responseReceivedRef.current = false;
    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}`;
    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;

      const attachListeners = (websocket) => {
        websocket.onopen = () => {
          console.log("WebSocket connection established");
          reconnectAttempts.current = 0;
          isConnectingRef.current = false;
          if (lastMessageRef.current) {
            websocket.send(lastMessageRef.current);
          }
          if (messageQueueRef.current.length > 0) {
            messageQueueRef.current.forEach((msgs) => {
              if (websocket.readyState === WebSocket.OPEN) {
                websocket.send(msgs);
              }
            });
            messageQueueRef.current = [];
          }
          startPingInterval(websocket);
        };
        attachWebSocketListeners(websocket);
      };

      attachListeners(ws);
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      handleReconnect();
    }
  }, [
    UploadedResumes,
    parsedFiles,
    failedFiles,
    setIsUploading,
    setParsedFiles,
    setFailedFiles,
    uploadType,
  ]);

  const attachWebSocketListeners = (ws) => {
    ws.onmessage = (event) => {
      if (event.data === "pong") {
        console.warn("Pong received");
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        return;
      }
      try {
        console.log("Raw WebSocket message:", event.data);
        const cleanedMessage = event.data.trim();
        const messageParts = cleanedMessage.split(/\|(.+)/, 2);
        if (messageParts.length === 2) {
          const topic = messageParts[0];
          const rawData = messageParts[1];
          const baseTopic = topic;
          if (baseTopic === `process-resume-blob-completed:${resumeRunIdRef.current}`) {
            try {
              const jsonData = JSON.parse(rawData);
              console.log("Received process-resume-blob-completed:", jsonData);
              let parsedResume = {};
              try {
                parsedResume = jsonData.parsed_resume
                  ? JSON.parse(jsonData.parsed_resume)
                  : {};
              } catch (parseError) {
                console.error(
                  "Failed to parse parsed_resume:",
                  jsonData.parsed_resume,
                  parseError,
                );
                parsedResume = {};
              }
              const fileName = jsonData.name || jsonData.id;
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
              setParsedData((prevResumes) => {
                const isExisting = prevResumes.some(
                  (resume) => resume.id === jsonData.id,
                );
                return isExisting
                  ? prevResumes
                  : [
                      ...prevResumes,
                      { ...jsonData, parsed_resume: parsedResume },
                    ];
              });
              setParsedResumeData(parsedResume);
              const parsedFile = UploadedResumes.find(
                (file) => file.name === fileName,
              );
              if (parsedFile) {
                setParsedFiles((prevFiles) => {
                  if (!prevFiles.some((file) => file.name === fileName)) {
                    return [...prevFiles, parsedFile];
                  }
                  return prevFiles;
                });
              }
              setSuccessMessages((prevMessages) => [
                ...prevMessages,
                `Candidate created successfully for ${fileName}`,
              ]);
            } catch (jsonError) {
              console.error("Invalid JSON in rawData:", rawData, jsonError);
            }
          } else if (baseTopic === `process-resume-blob-incomplete:${resumeRunIdRef.current}`) {
            try {
              const incompleteData = JSON.parse(rawData);
              const fileName = incompleteData.name;
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
              setIncompleteData((prevData) => {
                const isExisting = prevData.some(
                  (data) => data.id === incompleteData.id,
                );
                return isExisting
                  ? prevData
                  : [
                      ...prevData,
                      {
                        ...incompleteData,
                        parsed_resume: incompleteData.parsed_resume
                          ? JSON.parse(incompleteData.parsed_resume)
                          : {},
                      },
                    ];
              });
              const incompleteFile = UploadedResumes.find(
                (file) => file.name === fileName,
              );
              if (incompleteFile) {
                setIncompleteFiles((prevFiles) => {
                  const filtered = prevFiles.filter(
                    (file) => file.name !== fileName,
                  );
                  return [...filtered, incompleteFile];
                });
                setFailedFiles((prev) =>
                  prev.filter((file) => file.name !== fileName),
                );
              }
            } catch (jsonError) {
              console.error(
                "Failed to parse incomplete data:",
                rawData,
                jsonError,
              );
              try {
                let jsonString = rawData;
                if (typeof jsonString === "string") {
                  if (jsonString.startsWith('"') && jsonString.endsWith('"')) {
                    jsonString = jsonString.slice(1, -1);
                  }
                  jsonString = jsonString.replace(/\\"/g, '"');
                  const incompleteData = JSON.parse(jsonString);
                  const fileName = incompleteData.name;
                  const incompleteFile = UploadedResumes.find(
                    (file) => file.name === fileName,
                  );
                  if (incompleteFile) {
                    setIncompleteFiles((prevFiles) => [
                      ...prevFiles,
                      { ...incompleteFile, id: incompleteData.id },
                    ]);
                    setIncompleteData((prevData) => [
                      ...prevData,
                      incompleteData,
                    ]);
                    setErrorMessages((prevMessages) => [
                      ...prevMessages,
                      `${fileName}: Incomplete parsing (fallback)`,
                    ]);
                  }
                }
              } catch (fallbackError) {
                console.error("Fallback parsing also failed:", fallbackError);
              }
            }
          }
          if (baseTopic === `process-resume-blob-err:${resumeRunIdRef.current}`) {
            try {
              let jsonString = rawData;
              if (jsonString.startsWith('"') && jsonString.endsWith('"')) {
                jsonString = jsonString.slice(1, -1);
              }
              jsonString = jsonString.replace(/\\"/g, '"');
              const errorData = JSON.parse(jsonString);
              const fileName = errorData.name;
              const errorMessage = errorData.message;
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
              if (retryFilesRef.current.has(fileName)) {
                console.log(
                  `Retry file ${fileName} received error via WebSocket, waiting for polling...`,
                );
                return;
              }
              if (showFailedTab) {
                setErrorMessages((prevMessages) => [
                  ...prevMessages,
                  `${fileName}: ${errorMessage}`,
                ]);
                const failedFile = UploadedResumes.find(
                  (file) => file.name === fileName,
                );
                if (failedFile) {
                  setFailedFiles((prevFiles) => {
                    if (!prevFiles.some((file) => file.name === fileName)) {
                      return [...prevFiles, failedFile];
                    }
                    return prevFiles;
                  });
                }
              }
            } catch (jsonError) {
              console.error("Failed to parse error data:", rawData, jsonError);
            }
          }
          if (
            parsedFiles.length + failedFiles.length + incompleteFiles.length ===
              UploadedResumes.length &&
            UploadedResumes.length > 0
          ) {
            if (
              runActiveRef.current &&
              parsedFiles.length +
                failedFiles.length +
                incompleteFiles.length ===
                UploadedResumes.length &&
              UploadedResumes.length > 0
            ) {
              if (!allProcessedHandledRef.current) {
                allProcessedHandledRef.current = true;
                runActiveRef.current = false;
                console.log("All files processed, closing WebSocket");
                setIsUploading(false);
                closeWebSocket();
                if (countdownIntervalRef.current) {
                  clearInterval(countdownIntervalRef.current);
                  countdownIntervalRef.current = null;
                  setCountdown(null);
                }
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current);
                  timeoutRef.current = null;
                }
                Toast("success", "All files have been processed.");
              }
            }
          }
          if (baseTopic === `process-excel-blob-completed:${excelRunIdRef.current}`) {
            try {
              const jsonData = JSON.parse(rawData);
              console.log("Received process-excel-blob-completed:", jsonData);
              if (jsonData.candidate_id) {
                setSpreadsheetResults((prev) => {
                  const exists = prev.some(
                    (item) =>
                      item.candidate_id === jsonData.candidate_id &&
                      item.name === jsonData.name,
                  );
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        ...jsonData,
                        candidate_creation_status:
                          jsonData.candidate_creation_status,
                        created_at:
                          jsonData.created_at || new Date().toISOString(),
                      },
                    ];
                  }
                  return prev;
                });
                setSpreadsheetLoading(false);
                setIsUploading(false);
              }
              const fileName = jsonData.name || jsonData.id;
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
            } catch (jsonError) {
              console.error("Invalid JSON in rawData:", rawData, jsonError);
            }
          } else if (baseTopic === `process-excel-blob-incomplete:${excelRunIdRef.current}`) {
            try {
              const incompleteData = JSON.parse(rawData);
              console.log("Received process-excel-blob-incomplete:", incompleteData);
              
              const fileName = incompleteData.name || incompleteData.id;
              const errorMessage = incompleteData.message || "Incomplete processing";
              setFailedSpreadsheets((prev) => {
                const exists = prev.some((file) => file.name === fileName);
                if (!exists) {
                  return [
                    ...prev,
                    {
                      name: fileName,
                      error: errorMessage,
                      id: incompleteData.id,
                      createdAt: incompleteData.created_at || new Date().toISOString(),
                      isIncomplete: true,
                    },
                  ];
                }
                return prev;
              });
              if (incompleteData.candidate_id) {
                setSpreadsheetResults((prev) => {
                  const exists = prev.some(
                    (item) =>
                      item.candidate_id === incompleteData.candidate_id &&
                      item.name === incompleteData.name,
                  );
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        ...incompleteData,
                        candidate_creation_status: "incomplete",
                        created_at: incompleteData.created_at || new Date().toISOString(),
                      },
                    ];
                  }
                  return prev;
                });
              }
              
              setSpreadsheetLoading(false);
              setIsUploading(false);
              
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
            } catch (jsonError) {
              console.error("Failed to parse incomplete data:", rawData, jsonError);
            }
          } else if (baseTopic === `process-excel-blob-err:${excelRunIdRef.current}`) {
            try {
              let jsonString = rawData;
              if (jsonString.startsWith('"') && jsonString.endsWith('"')) {
                jsonString = jsonString.slice(1, -1);
              }
              jsonString = jsonString.replace(/\\"/g, '"');
              const errorData = JSON.parse(jsonString);
              const fileName = errorData.name;
              const errorMessage =
                errorData.metadata?.error ||
                errorData.message ||
                "Unknown error";
              console.log("Excel processing error:", errorData);
              setFailedSpreadsheets((prev) => {
                const exists = prev.some((file) => file.name === fileName);
                if (!exists) {
                  return [
                    ...prev,
                    {
                      name: fileName,
                      error: errorMessage,
                      id: errorData.id,
                      createdAt:
                        errorData.created_at || new Date().toISOString(),
                    },
                  ];
                }
                return prev;
              });
              setSpreadsheetLoading(false);
              setIsUploading(false);
              if (timeoutsRef.current[fileName]) {
                clearTimeout(timeoutsRef.current[fileName]);
                delete timeoutsRef.current[fileName];
              }
            } catch (jsonError) {
              console.error("Failed to parse error data:", rawData, jsonError);
            }
          }
        } else {
          try {
            const jsonData = JSON.parse(event.data);
            if (jsonData.id && jsonData.parsed_resume) {
              console.log(
                "Fallback: Parsed as process-resume-blob-completed:",
                jsonData,
              );
            }
          } catch (fallbackError) {
            console.error("Fallback parsing failed:", fallbackError);
          }
        }
        responseReceivedRef.current = true;
      } catch (error) {
        console.error("Error processing WebSocket message:", error);
        setErrorMessages((prevMessages) => [
          ...prevMessages,
          `Error: ${event.data}`,
        ]);
      }
    };
    ws.onclose = (event) => {
      console.log("WebSocket connection closed", event);
      isConnectingRef.current = false;
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
        pingIntervalRef.current = null;
      }
      if (pingTimeoutRef.current) {
        clearTimeout(pingTimeoutRef.current);
        pingTimeoutRef.current = null;
      }
      if (
        event.code === 1006 ||
        (!responseReceivedRef.current && event.code !== 1000)
      ) {
        console.log(
          `Connection closed with code ${event.code}, attempting to reconnect...`,
        );
        handleReconnect();
      }
    };
    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      isConnectingRef.current = false;
    };
  };

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
      ws.send("ping");
      pingTimeoutRef.current = setTimeout(() => {
        console.log("No pong received within timeout, reconnecting...");
        ws.close(1000, "Ping timeout");
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.warn("Sending ping");
        ws.send("ping");
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }
        pingTimeoutRef.current = setTimeout(() => {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);
  const handleReconnect = useCallback(() => {
    if (reconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS) {
      Toast("error", "Max reconnection attempts reached. Please refresh.");
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts.current) +
        Math.random() * 1000,
      30000,
    );
    reconnectTimeoutRef.current = setTimeout(() => {
      reconnectAttempts.current += 1;
      initializeWebSocket();
    }, delay);
  }, [initializeWebSocket]);

  useEffect(() => {
    if (uploadType === "spreadsheet" && spreadsheetLoading) {
      initializeWebSocket();
    }
  }, [uploadType, spreadsheetLoading, initializeWebSocket]);

  const handleFileRemove = (index) => {
    setUploadedResumes((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };
  const resetComponentState = useCallback(() => {
    setParsedData([]);
    setSuccessMessages([]);
    setErrorMessages([]);
    setIsUploading(false);
    setLoading(false);
    setParsedFiles([]);
    setFailedFiles([]);
    setIncompleteFiles([]);
    setIncompleteData([]);
    setRunSetId(null);
    setShowFailedTab(false);
    setRetryApiResponses({});
    setShowSpreadsheetResults(false);
    localStorage.removeItem("retryApiResponses");
  }, [setUploadedResumes, setIsUploading, setParsedFiles, setFailedFiles]);
  useEffect(() => {
    if ((!showResumeParser && !showSpreadsheetResults) || resetWebSocket) {
      resetComponentState();
    }
  }, [
    showResumeParser,
    showSpreadsheetResults,
    resetWebSocket,
    resetComponentState,
  ]);
  const handleRetryAllFailed = async (failedFiles) => {
    try {
      const updatedRetryCounts = { ...failedFileRetryCounts };
      failedFiles.forEach((file) => {
        updatedRetryCounts[file.name] =
          (updatedRetryCounts[file.name] || 0) + 1;
      });
      setFailedFileRetryCounts(updatedRetryCounts);
      const newRunSetId = await createRunSetIdForRetry(failedFiles);
      if (!newRunSetId) {
        Toast("error", "Failed to create new retry session");
        return false;
      }
      retryRunSetIdRef.current = newRunSetId;
      failedFiles.forEach((file) => {
        retryFilesRef.current.add(file.name);
      });
      const failedFileNames = failedFiles.map((file) => file.name);
      const token = localStorage.getItem("token");
      const requestBody = JSON.stringify({ FileNames: failedFileNames });
      const response = await fetch(RESUME_PARSER_BASE_URL + PARSED_RESUME_URL, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });
      const data = await response.json();
      const presignedUrls = data.PresignedUploadURLs;
      if (!presignedUrls || presignedUrls.length === 0) {
        Toast("error", "Failed to get upload URLs");
        return false;
      }
      const uploadPromises = failedFiles.map((file, index) => {
        const presignedUrl = presignedUrls[index];
        return fetch(presignedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": "application/octet-stream",
          },
        });
      });
      await Promise.all(uploadPromises);
      const processResponse = await processUploadedFileForRetry(
        failedFileNames,
        newRunSetId,
      );
      if (processResponse) {
        initializeWebSocket();
        const responses = await scheduleUnparsedResumesCountForRetry(
          newRunSetId,
          failedFiles,
        );
        Toast("success", `Retrying ${failedFiles.length} failed file(s)`);
        return {
          success: true,
          runSetId: newRunSetId,
          responses: responses,
          finalResponse: retryApiResponses[newRunSetId],
        };
      }
      return { success: false };
    } catch (error) {
      console.error("Error retrying failed files:", error);
      Toast("error", "Failed to retry files");
      return { success: false, error: error.message };
    }
  };
  const scheduleUnparsedResumesCountForRetry = async (runSetId, retryFiles) => {
    if (!runSetId) {
      console.error(
        "No runSetId provided for scheduleUnparsedResumesCountForRetry",
      );
      return;
    }
    const retryFileNames = new Set(retryFiles.map((f) => f.name));
    const MAX_RETRY_POLLING_ATTEMPTS = 10;
    const retryResponses = [];
    const callUnparsedResumesCountForRetry = async (attemptCount) => {
      try {
        const unparsedData = await getUnparsedResumesCount(runSetId);
        retryResponses.push({
          attempt: attemptCount,
          timestamp: new Date().toISOString(),
          data: unparsedData,
        });
        console.log(
          `Retry Attempt ${attemptCount} resumes count response:`,
          unparsedData,
        );
        if (unparsedData) {
          const completedSet = new Set(
            unparsedData.completed_files?.map((f) => f.name) || [],
          );
          const incompleteSet = new Set(
            unparsedData.incomplete_files?.map((f) => f.name) || [],
          );
          const retryCompleted =
            unparsedData.completed_files?.filter((file) =>
              retryFileNames.has(file.name),
            ) || [];
          const retryIncomplete =
            unparsedData.incomplete_files?.filter((file) =>
              retryFileNames.has(file.name),
            ) || [];
          if (retryCompleted.length > 0) {
            const completed = retryCompleted.map((file) => ({
              id: file.id,
              name: file.name,
              presigned_url: file.presigned_url,
              candidate_id: file.candidate_id,
              candidate_creation_status: file.candidate_creation_status,
              created_at: file.created_at,
              updated_at: file.updated_at,
            }));
            setParsedData((prev) => {
              const newCompletedItems = completed.map((newFile) => {
                const existingFile = prev.find((p) => p.name === newFile.name);
                if (existingFile) {
                  return {
                    ...newFile,
                    created_at: newFile.created_at || existingFile.created_at,
                    updated_at: newFile.updated_at || existingFile.updated_at,
                  };
                }
                return newFile;
              });
              return [...prev.filter((p) => !completedSet.has(p.name)), ...newCompletedItems];
            });
            retryCompleted.forEach((file) => {
              const retryFile = retryFiles.find((f) => f.name === file.name);
              if (retryFile) {
                setParsedFiles((prev) => {
                  if (!prev.some((f) => f.name === file.name)) {
                    return [...prev, retryFile];
                  }
                  return prev;
                });
              }
            });
            setSuccessMessages((prevMessages) => [
              ...prevMessages,
              ...retryCompleted.map(
                (file) =>
                  `Candidate created successfully for ${file.name} (retry)`,
              ),
            ]);
            retryCompleted.forEach((file) => {
              retryFilesRef.current.delete(file.name);
            });
          }
          if (retryIncomplete.length > 0) {
            const incomplete = retryIncomplete.map((file) => ({
              id: file.id,
              name: file.name,
              presigned_url: file.presigned_url,
            }));
            setIncompleteData((prev) => [
              ...prev.filter((i) => !incompleteSet.has(i.name)),
              ...incomplete,
            ]);
            retryIncomplete.forEach((file) => {
              const retryFile = retryFiles.find((f) => f.name === file.name);
              if (retryFile) {
                setIncompleteFiles((prev) => {
                  const filtered = prev.filter((f) => f.name !== file.name);
                  return [...filtered, retryFile];
                });
              }
            });
            retryIncomplete.forEach((file) => {
              retryFilesRef.current.delete(file.name);
            });
          }
          if (attemptCount >= MAX_RETRY_POLLING_ATTEMPTS) {
            const stillRunningFiles = Array.from(retryFilesRef.current);
            if (stillRunningFiles.length > 0) {
              console.log(
                `Marking ${stillRunningFiles.length} retry files as failed after max attempts`,
              );
              const failedRetryFiles = retryFiles.filter((file) =>
                stillRunningFiles.includes(file.name),
              );
              setFailedFiles((prev) => {
                const newFailed = failedRetryFiles.filter(
                  (file) => !prev.some((f) => f.name === file.name),
                );
                return [...prev, ...newFailed];
              });
              setErrorMessages((prevMessages) => [
                ...prevMessages,
                ...failedRetryFiles.map(
                  (file) => `${file.name}: Failed to parse after retry`,
                ),
              ]);
              retryFilesRef.current.clear();
            }
          }
        }
        if (
          attemptCount >= MAX_RETRY_POLLING_ATTEMPTS ||
          retryFilesRef.current.size === 0
        ) {
          setRetryApiResponses((prev) => ({
            ...prev,
            [runSetId]: {
              finalStatus: {
                completed: unparsedData.completed_files || [],
                failed: unparsedData.failed_files || [],
                incomplete: unparsedData.incomplete_files || [],
              },
            },
          }));
        }
        return unparsedData;
      } catch (error) {
        console.error("Error in callUnparsedResumesCountForRetry:", error);
        retryResponses.push({
          attempt: attemptCount,
          timestamp: new Date().toISOString(),
          error: error.message,
          data: null,
        });
      }
    };
    await callUnparsedResumesCountForRetry(1);
    let attemptCount = 1;
    unparsedCountIntervalRef.current = setInterval(async () => {
      attemptCount += 1;
      await callUnparsedResumesCountForRetry(attemptCount);
      if (
        retryFilesRef.current.size === 0 ||
        attemptCount >= MAX_RETRY_POLLING_ATTEMPTS
      ) {
        clearInterval(unparsedCountIntervalRef.current);
        unparsedCountIntervalRef.current = null;
        if (retryFilesRef.current.size === 0) {
          Toast("success", "All retry files have been processed");
        }
        return retryResponses;
      }
    }, 30000);
  };
  const createRunSetIdForRetry = async (failedFiles) => {
    try {
      const response = await post(VYLABS_BASE_URL, CREATE_RUN_SET_ID, {
        folderName: failedFiles.map((file) => file.name).join(","),
        totalFiles: failedFiles.length,
        isRetry: true,
      });
      return response;
    } catch (error) {
      console.error("Error creating retry run set ID:", error);
      return null;
    }
  };
  const processUploadedFileForRetry = async (fileNames, runSetId) => {
    const token = localStorage.getItem("token");
    const requestBodyData = {
      fileNames: fileNames,
      runSetID: runSetId,
    };
    const requestBody = JSON.stringify(requestBodyData);
    try {
      const response = await fetch(
        RESUME_PARSER_BASE_URL + PROCESS_UPLOAD_FILE,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: requestBody,
        },
      );
      return response.ok;
    } catch (error) {
      console.error("Error processing retry:", error);
      return false;
    }
  };
  const CustomToggle = ({ value, onChange, options }) => {
    return (
      <div
        className="custom-upload-toggle"
        role="radiogroup"
        aria-label="Upload type toggle"
      >
        {options.map((option, index) => {
          const isSelected = value === option.value;
          const IconComponent = option.icon;
          return (
            <button
              key={option.value}
              type="button"
              className={`toggle-btn ${isSelected ? "selected" : ""}`}
              onClick={() => onChange(null, option.value)}
              role="radio"
              aria-checked={isSelected}
              tabIndex={isSelected ? 0 : -1}
              style={{
                borderRadius:
                  index === 0
                    ? "10px 0 0 10px"
                    : index === options.length - 1
                      ? "0 10px 10px 0"
                      : "0",
              }}
            >
              <IconComponent
                style={{ marginRight: "8px", width: "20px", height: "20px" }}
              />
              {option.label}
            </button>
          );
        })}
      </div>
    );
  };
  return (
    <div className="resume-upload-container">
      <>
        {showResumeParser && uploadType === "resume" ? (
          <ResumeParser
            isLoading={loading}
            setIsLoading={setLoading}
            UploadedResumes={UploadedResumes}
            parsedResumeData={parsedResumeData}
            successMessages={successMessages}
            errorMessages={errorMessages}
            parsedData={parsedData}
            setParsedData={setParsedData}
            setIncompleteData={setIncompleteData}
            setRunSetId={setRunSetId}
            setErrorMessages={setErrorMessages}
            setSuccessMessages={setSuccessMessages}
            setShowFailedTab={setShowFailedTab}
            setUploadedResumes={setUploadedResumes}
            setShowResumeParser={setShowResumeParser}
            parsedFiles={parsedFiles}
            failedFiles={failedFiles}
            handleRetryAllFailed={handleRetryAllFailed}
            retryApiResponses={retryApiResponses}
            failedFileRetryCounts={failedFileRetryCounts}
            showHeader={showHeader}
            countdown={countdown}
            incompleteFiles={incompleteFiles}
            incompleteData={incompleteData}
            setParsedFiles={setParsedFiles}
            setFailedFiles={setFailedFiles}
            setIncompleteFiles={setIncompleteFiles}
            showFailedTab={showFailedTab}
          />
        ) : uploadType === "spreadsheet" && showSpreadsheetResults ? (
          <SpreadsheetResults
            UploadedResumes={UploadedResumes}
            spreadsheetResults={spreadsheetResults}
            setUploadedResumes={setUploadedResumes}
            showHeader={showHeader}
            setSpreadsheetResults={setSpreadsheetResults}
            failedSpreadsheets={failedSpreadsheets}
            setFailedSpreadsheets={setFailedSpreadsheets}
            resetSpreadsheetState={() => {
              closeWebSocket();
              setCountdown(null);
              setSpreadsheetLoading(false);
              setIsUploading(false);
              setShowSpreadsheetResults(false);
            }}
          />
        ) : (
          <div className="upload-resume-container">
            {showHeader && (
              <div className="header-main-container">
                <div className="header-icon-title-button-container">
                  <div className="header-icon-title-container">
                    {isComingFromCandidates ? (
                      <img
                        alt=""
                        src={
                          isDarkMode ? CandidateDarkIcon : CandidateLightIcon
                        }
                        className="header-title-icon"
                      ></img>
                    ) : (
                      <img
                        alt=""
                        src={isDarkMode ? RPHeaderDarkIcon : RPHeaderLightIcon}
                        className="header-title-icon"
                      ></img>
                    )}
                    <h2 className="upload-resume-header">
                      {" "}
                      {isComingFromCandidates ? "Candidates" : "Resume Parser"}
                    </h2>
                  </div>

                  <div className="right-side-button-container">
                    {isVendorFeatureEnabled && uploadType === "resume" && (
                      <CustomTooltip
                        title="The selected vendor will be assigned to all parsed resume candidates."
                        arrow
                      >
                        <Button
                          label="Assign Vendor"
                          event={handleAddVendorClick}
                        />
                      </CustomTooltip>
                    )}
                    <div className="upload-type-toggle">
                      <CustomToggle
                        value={uploadType}
                        onChange={handleUploadTypeChange}
                        options={[
                          {
                            value: "resume",
                            label: "Resume",
                            icon: ResumeIcon,
                          },
                          {
                            value: "spreadsheet",
                            label: "Spreadsheet",
                            icon: SpreadsheetIcon,
                          },
                        ]}
                      />
                    </div>
                    {isComingFromCandidates && (
                      <div className="back-to-list-button">
                        <Button
                          label="Back"
                          event={handleCloseUploadResumeView}
                          iconSrc={backArrowIcon}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="outer-main-container">
              <div className="outer-container">
                <div
                  className="page-intro"
                  style={{
                    textAlign: "center",
                    maxWidth: "800px",
                    margin: "0 auto 30px",
                    padding: "0 20px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      lineHeight: "1.6",
                      color: isDarkMode
                        ? "rgba(255, 255, 255, 0.7)"
                        : "rgba(0, 0, 0, 0.6)",
                      marginBottom: "10px",
                    }}
                  >
                    {uploadType === "resume"
                      ? "Upload candidate resumes to parse and automatically extract relevant information. Our system will process them to create candidate profiles."
                      : "Upload a spreadsheet to bulk create candidates. Import from Excel to create multiple candidate profiles at once."}
                  </p>
                  <div style={{ width: "100%", margin: "30px 0" }}>
                    <Stepper
                      activeStep={0}
                      alternativeLabel
                      sx={{
                        "& .MuiStepIcon-root": {
                          color: "#6860EE",
                          fontSize: "2.5rem",
                        },
                        "& .MuiStepConnector-root": {
                          top: "calc(50% - 20px)",
                          left: "calc(-50% + 40px)",
                          right: "calc(50% + 40px)",
                          transform: "none",
                        },
                        "& .MuiStepConnector-line": {
                          position: "relative",
                          borderWidth: 1,
                          borderColor: "#6860EE",
                          borderStyle: "dashed",
                          "&::before, &::after": {
                            content: '""',
                            position: "absolute",
                            top: "50%",
                            width: "8px",
                            height: "8px",
                            backgroundColor: "#6860EE",
                            borderRadius: "50%",
                            transform: "translateY(-50%)",
                          },
                          "&::before": { left: "-4px" },
                          "&::after": { right: "-4px" },
                        },
                        "& .MuiStepIcon-root.Mui-active": { color: "#6860EE" },
                        "& .MuiStepIcon-root.Mui-completed": {
                          color: "#6860EE",
                        },
                        "& .MuiStepLabel-label": {
                          color: "#6860EE !important",
                          fontSize: "1rem",
                          fontWeight: 500,
                          fontFamily: "Satoshi, sans-serif",
                        },
                        "&.MuiStepLabel-label.Mui-active": {
                          color: "#6860EE !important",
                        },
                        "&.MuiStepLabel-label.Mui-completed": {
                          color: "#6860EE",
                        },
                      }}
                    >
                      <Step
                        key={
                          uploadType === "resume"
                            ? "Upload resumes"
                            : "Upload spreadsheet"
                        }
                      >
                        <StepLabel>
                          {uploadType === "resume"
                            ? "Upload resumes"
                            : "Upload spreadsheet"}
                        </StepLabel>
                      </Step>
                      <Step
                        key={
                          uploadType === "resume"
                            ? "System extracts data"
                            : "System processes data"
                        }
                      >
                        <StepLabel>
                          {uploadType === "resume"
                            ? "System extracts data"
                            : "System processes data"}
                        </StepLabel>
                      </Step>
                      <Step key="Candidate profiles created">
                        <StepLabel>Candidate profiles created</StepLabel>
                      </Step>
                    </Stepper>
                  </div>
                </div>
                <div
                  className={`file-upload-outer ${
                    isHeaderActive ? "active" : ""
                  }`}
                >
                  {UploadedResumes.length > 0 && (
                    <div
                      className="uploaded-files-name-list"
                      style={{
                        background: isDarkMode
                          ? "rgba(30, 30, 40, 0.7)"
                          : "white",
                        borderRadius: "16px",
                        padding: "20px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
                        marginBottom: "20px",
                        border: "1px solid var(--border__color)",
                        marginTop: "-10px",
                      }}
                    >
                      <div className="uploaded-files-name-list-container">
                        <h3
                          style={{
                            color: "#6860EE",
                            borderBottom: "1px solid var(--border__color)",
                            paddingBottom: "16px",
                            marginTop: "4px",
                            marginBottom: "12px",
                            fontSize: "18px",
                            fontWeight: "600",
                          }}
                        >
                          {uploadType === "resume" ? "Resumes" : "Spreadsheets"}{" "}
                          <span className="resume-length-span">
                            {UploadedResumes?.length}
                          </span>
                        </h3>
                        <div
                          className="file-and-folder-container"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            maxHeight: "250px",
                            overflowY: "auto",
                            padding: "5px",
                          }}
                        >
                          {UploadedResumes.length > 0 && (
                            <>
                              {UploadedResumes.map((file, index) => (
                                <div
                                  className="file-container"
                                  key={index}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "12px 16px",
                                    background: isDarkMode
                                      ? "rgba(34, 108, 226, 0.1)"
                                      : "rgba(34, 108, 226, 0.05)",
                                    borderRadius: "8px",
                                    transition: "all 0.2s ease",
                                    border: "1px solid rgba(34, 108, 226, 0.1)",
                                  }}
                                >
                                  <span
                                    className="file-name"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      fontSize: "15px",
                                      fontWeight: "500",
                                      color: isDarkMode ? "white" : "#333",
                                    }}
                                  >
                                    <FileIcon fileName={file.name} />
                                    {displayFileName(file.name)}
                                  </span>
                                  <CancelIcon
                                    sx={{
                                      cursor: "pointer",
                                      color: isDarkMode
                                        ? "rgba(255, 255, 255, 0.6)"
                                        : "#666",
                                      fontSize: "20px",
                                    }}
                                    onClick={() => handleFileRemove(index)}
                                  />
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                      <div
                        className="modal-buttons"
                        style={{
                          display: "flex",
                          gap: "15px",
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <Button
                          label="Clear"
                          backgroundColor={
                            isDarkMode ? "rgba(255, 255, 255, 0.1)" : "#F5F4F3"
                          }
                          color={isDarkMode ? "white" : "#7B7A7A"}
                          border={
                            isDarkMode
                              ? "1px solid rgba(255, 255, 255, 0.2)"
                              : "1px solid #ACACAC"
                          }
                          event={handleClear}
                          style={{
                            borderRadius: "8px",
                            padding: "8px 20px",
                            fontWeight: "500",
                            transition: "all 0.2s ease",
                          }}
                        />
                        {uploadType === "resume" && (
                          <Button
                            label={"Upload"}
                            backgroundColor="#6860EE"
                            event={handlesubmit}
                            iconSrc={uploadButton}
                            iconPosition="right"
                            iconWidth="15px"
                            style={{
                              borderRadius: "8px",
                              padding: "8px 20px",
                              fontWeight: "500",
                              boxShadow: "0 4px 12px rgba(34, 108, 226, 0.25)",
                              transition: "all 0.2s ease",
                            }}
                          />
                        )}
                        {uploadType === "spreadsheet" && (
                          <Button
                            label={
                              spreadsheetLoading ? "Importing..." : "Import"
                            }
                            backgroundColor="#6860EE"
                            event={handlesubmit}
                            iconSrc={uploadButton}
                            iconPosition="right"
                            iconWidth="15px"
                            style={{
                              borderRadius: "8px",
                              padding: "8px 20px",
                              fontWeight: "500",
                              boxShadow: "0 4px 12px rgba(34, 108, 226, 0.25)",
                              transition: "all 0.2s ease",
                            }}
                            disabled={spreadsheetLoading}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  <div className="Files-upload-container">
                    <div
                      className={`file-drop-container ${
                        isDragging ? "drag-over" : ""
                      }`}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      data-is-dragging={isDragging}
                      onClick={handleClickUpload}
                      style={{
                        background: isDarkMode
                          ? "rgba(20, 20, 30, 0.7)"
                          : "rgba(255, 255, 255, 0.9)",
                        borderRadius: "16px",
                        backdropFilter: "blur(10px)",
                        padding: "40px 20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.3s ease",
                        transform: isDragging ? "scale(1.02)" : "scale(1)",
                        border: isDragging
                          ? "2px dashed #4138e057"
                          : isDarkMode
                            ? "2px dashed rgba(255, 255, 255, 0.3)"
                            : "2px dashed rgba(34, 108, 226, 0.3)",
                        height: "89%",
                        margin: "2vw auto",
                        marginTop: "115px",
                      }}
                    >
                      <label
                        htmlFor="Files-upload"
                        className="file-upload-label"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            borderRadius: "50%",
                            width: "80px",
                            height: "80px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: isDarkMode
                              ? "rgba(104, 96, 238, 0.1)"
                              : "rgba(104, 96, 238, 0.05)",
                          }}
                        >
                          <img
                            src={
                              uploadType === "resume" ? UploadIcon : UploadIcon
                            }
                            alt={
                              uploadType === "resume"
                                ? "Upload Resume"
                                : "Upload Spreadsheet"
                            }
                            style={{
                              cursor: "pointer",
                              width: "40px",
                              height: "40px",
                              color: isDarkMode ? "#ffffff" : "#6860EE",
                            }}
                            onClick={handleClickUpload}
                          />
                        </div>
                        <p
                          className="drag-drop"
                          style={{
                            cursor: "pointer",
                            fontSize: "18px",
                            fontWeight: "500",
                            color: isDarkMode ? "#ffffff" : "#6860EE",
                            margin: "10px 0 5px",
                          }}
                        >
                          {uploadType === "resume"
                            ? "Drag & Drop or Click to upload the resumes"
                            : "Drag & Drop or Click to upload spreadsheet"}
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                            color: isDarkMode
                              ? "rgba(255, 255, 255, 0.6)"
                              : "rgba(0, 0, 0, 0.6)",
                            marginTop: "5px",
                          }}
                        >
                          {uploadType === "resume"
                            ? "PDF, DOC, DOCX,TXT and HTML files. Single or Multiple files supported."
                            : "XLSX, CSV files. Single or multiple files supported."}
                        </p>
                        <input
                          type="file"
                          ref={fileRef}
                          onChange={handleFileInputChange}
                          style={{ display: "none" }}
                          multiple
                          accept={
                            uploadType === "resume"
                              ? ".pdf,.doc,.docx,.txt,.html"
                              : ".xlsx,.csv"
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showVendorPopup && (
              <StandardPopup
                isOpen={showVendorPopup}
                onClose={() => setShowVendorPopup(false)}
                onSubmit={() => assignVendorToCandidates(selectedVendorId)}
                title={"Assign Vendor"}
                submitLabel="Assign Vendor"
                cancelLabel="Cancel"
                width="40vw"
              >
                <div className="popup-field">
                  <div className="vendor-assignment-popup">
                    <p>
                      The selected vendor will be assigned to all parsed resume
                      candidates :
                    </p>
                    <div className="form-group">
                      <label htmlFor="vendorID" className="textfield-label">
                        Vendor
                      </label>
                      <DynamicAutocomplete
                        key="vendor-assignment-autocomplete"
                        onChange={(value) => {
                          setSelectedVendorId(value?.value || "");
                          if (!value) {
                            setVendorList([]);
                          }
                        }}
                        value={
                          selectedVendorId
                            ? vendorList.find(
                                (vendor) => vendor.value === selectedVendorId,
                              ) || null
                            : null
                        }
                        placeholder={"Select Vendor"}
                        minCharsForSearch={3}
                        noOptionsText="No Vendor found."
                        onInputChange={handleVendorInputChange}
                        options={vendorList}
                        loading={vendorOptionLoading}
                        sx={{
                          mt: "5px",
                          ".MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            height: "40px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              border:
                                "1px solid var(--border__color) !important",
                              borderRadius: "12px",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#6860ee",
                              borderRadius: "12px",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#7a70f2",
                              borderRadius: "12px",
                            },
                          },
                          ".MuiInputBase-input": {
                            color: "var(--header__color)",
                            padding: "8px 12px !important",
                            height: "40px",
                            fontFamily: "Satoshi !important",
                          },
                        }}
                        slotProps={{
                          paper: {
                            sx: {
                              backgroundColor: "var(--body__background)",
                              color: "var(--header__color)",
                              borderRadius: "12px",
                              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                              border: "1px solid var(--border__color)",
                            },
                          },
                          listbox: {
                            sx: {
                              "& li": {
                                fontSize: "14px",
                                fontWeight: 500,
                                padding: "8px 16px",
                                color: "var(--header__color)",
                                "&:hover": {
                                  backgroundColor: "rgba(0,0,0,0.04)",
                                },
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </StandardPopup>
            )}
          </div>
        )}
      </>
    </div>
  );
}
export default FileUploadContainer;